import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SvgIconComponentFactory } from 'projects/shared/svg-icons/svg-icon-component-factory';
import { SvgIconHostDirective } from 'projects/shared/svg-icons/svg-icon-host.directive';
import { Option } from '../../../models/wizard/option.model';
import { getOptionLabel } from '../../../models/wizard/option-utils';
import { LocalizedEditService } from '../../../transloco/localized-edit.service';

@Component({
    selector: 'answer-option',
    templateUrl: 'answer-option.component.html',
    styleUrls: ['answer-option.component.scss'],
    standalone: false
})

export class AnswerOptionComponent implements OnInit {

  @Input()
  option!: Option;

  @Input()
  inEditMode: boolean = true;

  @Output() optionSelected = new EventEmitter<Option>();

  @ViewChild(SvgIconHostDirective, { static: true }) svgIconHost!: SvgIconHostDirective;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _svgIconFactory: SvgIconComponentFactory,
    public readonly i18n: LocalizedEditService,
    private readonly _transloco: TranslocoService,
  ) { }

  getLabel = (field: 'text' | 'explanation'): string => {
    return getOptionLabel(this.option, field, this._transloco.getActiveLang());
  }

  getOptionSelectedEmitter = () => {
    return this.optionSelected;
  }

  onOptionSelected = (option: Option) => {
    this.optionSelected.emit(option);
  }

  loadIcon() {
    if (!this.option.iconName || this.option.iconType !== "svg") {
      return;
    }
    const svgIconComponent = this._svgIconFactory.getSvIconComponent(this.option.iconName);
    if (!svgIconComponent) {
      return;
    }
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(svgIconComponent);

    const viewContainerRef = this.svgIconHost.viewContainerRef;
    viewContainerRef.clear();

    viewContainerRef.createComponent(componentFactory);
  }

  ngOnInit() {
    this.loadIcon();
  }
}
